/*
  Стрелка «назад».

  Если покупатель пришёл с нашего же сайта — возвращаем его ровно туда, откуда
  он пришёл, вместе с прокруткой и выбранными фильтрами. Из поиска, из письма
  или по прямой ссылке истории нет, и тогда срабатывает обычная ссылка на
  запасной адрес, прописанный в разметке.
*/
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-back-link]');
  if (!link) return;
  let sameSite = false;
  try {
    sameSite = !!document.referrer
      && new URL(document.referrer).origin === window.location.origin;
  } catch (error) {
    sameSite = false;
  }
  if (sameSite && window.history.length > 1) {
    event.preventDefault();
    window.history.back();
  }
});
